module.exports = __webpack_public_path__ + "img/compare-cta.553de948.svg";